import { withNamespaces } from 'react-i18next';
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Spinner
} from 'reactstrap';

const DecisionModal = ({
    t,
    isOpen,
    toggle,
    type, // 'relevant' | 'false_positive'
    onConfirm,
    loading
}) => {
    const isRelevant = type === 'relevant';

    const title = isRelevant
        ? t('Mark as Relevant')
        : t('Mark as False Positive');

    const message = isRelevant
        ? t('Are you sure you want to mark this result as Relevant? This indicates a valid match and may require further action.')
        : t('Are you sure you want to mark this result as False Positive? This will exclude it from further consideration.');

    return (
        <Modal isOpen={isOpen} toggle={toggle} centered>
            <ModalHeader toggle={toggle}>
                {title}
            </ModalHeader>

            <ModalBody>
                {message}
            </ModalBody>

            <ModalFooter>
                <Button color="secondary" onClick={toggle} disabled={loading}>
                    {t('Cancel')}
                </Button>

                <Button
                    color={isRelevant ? 'danger' : 'success'}
                    onClick={onConfirm}
                    disabled={loading}
                >
                    {loading ? <Spinner size="sm" /> : 'Confirm'}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default withNamespaces()(
    DecisionModal
);